import * as Utils from "../utils/Config";
import { AuthContextModel } from '../App'
import { ApiClient } from "./ApiClient";
import { IOrthodonticLkgCfPatientExtension } from "../models/IOrthodonticLkgCfPatientExtension";

export class OrthodonticLkgCfPatientExtensionApi extends ApiClient {
    constructor(auth: AuthContextModel) {
        super(auth);
    }

    getOrthodonticLkgCfPatientExtension(id: number, success: (data: IOrthodonticLkgCfPatientExtension) => void, final?: () => void) {
        this.get<IOrthodonticLkgCfPatientExtension>(`${Utils.LIB_API_BASE_URL}/orthodonticLkgCfPatientExtension/${id}`, success, undefined, final)
    }

    downloadOrthodonticLkgCfPatientExtensionAttachment(orthodonticLkgCfPatientExtensionAttachmentId: number, fileName?: string, error?: (message: string) => void) {
        this.getFile(`${Utils.LIB_API_BASE_URL}/orthodonticLkgCfPatientExtension/file/${orthodonticLkgCfPatientExtensionAttachmentId}`, fileName ?? "", undefined, error);
    }
}